<template>
  <div class="end" :class="{'bg-empty':!!otherSettingBgImg}">
    <div ref="container" class="box-border px-4 pt-4">
      <end-success-header :tips="answerTextTips" />
      <template v-if="showErrorMessage">
        <div class="bg-white p-4 shadow-theme rounded-small mt-2">
          <div class="text-center text-theme-black-850 text-medium leading-22">
            <span>很遗憾，您提交答卷未过审</span>
          </div>
          <div class="text-small text-center text-theme-black-450 leading-18 break-words">
            <span>未过审原因：</span>
            <span>{{ auditDescription }}</span>
          </div>
        </div>
      </template>
      <template v-if="showAward">
        <award-answer-wrapper class="mt-4"/>
<!--        <end-award />-->
      </template>
      <template>
        <Coupon class="mt-3"/>
      </template>

      <template v-if="answerStatusIsOk">
        <extra-award v-if="extraChanceToGetAward" class="mt-4" />
      </template>
      <template v-if="surveyPoint">
        <survey-point class="mt-4" />
      </template>
      <div class="mt-4" v-if="enableLuck && !isIOSAPPHidden">
        <template v-if="showLuck">
          <template v-if="award && hasReward">
            <template v-if="isOpenReward">
              <luck :answer-id="answerId" :survey-id="surveyId" :bindEnabled="bindEnabled" />
            </template>
          </template>
          <template v-else>
            <luck :answer-id="answerId" :survey-id="surveyId" :bindEnabled="bindEnabled" />
          </template>
        </template>
      </div>
      <div id="TencentGDTContainer"></div>
      <template v-if="enableMoreSurvey">
        <more-survey class="mt-4" />
      </template>
    </div>
    <div ref="footerContainer" class="relative" style="padding: 54px 0">
      <div class="copyright">
        <!-- <span class="text-medium" v-if="showCopyright">调研工厂 提供技术支持</span> |
        <a target="_blank" class="text-medium text-theme-text-gray" href="https://survey.work/s/mZZZZfiJ">举报</a> -->
        <!-- 网站协议文案提示 -->
        <DygcFooter isReport v-if="footerStatus" />
        <template v-if="answerId">
          <div id="copyAnswerId" class="text-small mt-2" @click="onCopyAnswerId">
            <span class="text-small">{{ answerId }}</span>
            <span>
              <img src="~@/assets/img/svg/copy.svg" />
            </span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { busGetters, AnswerStatus, hasValue,copyText } from 'dygc'
import SplitBox from '@/components/SplitBox'
import EndSuccessHeader from '@/components/end/EndSuccessHeader'
import EndAward from '@/components/end/EndAward'
import RedRewardButton from '@/components/base/RedRewardButton'
import Luck from 'components/luck/Luck'
import { Notify } from 'vant'
import MoreSurvey from './end/MoreSurvey'
import ExtraAward from '@/components/end/ExtraAward'
import DygcFooter from 'components/dygc-footer-bottom/mobile'
import { initAnswerEndAdsense } from '../../plugins/adsense'
import SurveyPoint from '@/components/end/SurveyPoint'
import AwardAnswerWrapper from './reward/AwardAnswerWrapper.vue'
import Coupon from './end/Coupon.vue'

export default {
  name: 'AnswerEnd',
  components: { AwardAnswerWrapper,Coupon, SurveyPoint, ExtraAward, MoreSurvey, RedRewardButton, EndAward, EndSuccessHeader, SplitBox, Luck, DygcFooter },
  data() {
    return {
      textTips: [],
      isPlus: true
    }
  },
  props: {
    footerStatus: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    otherSettingBgImg(){
      const data = this.$bus.survey.otherSetting.background || {}
      const data1 = this.$bus.survey.otherSetting.answerEndBackground || {}
      return data.image || data1.image
    },
    answerStatusIsOk() {
      return [AnswerStatus.OK, AnswerStatus.PASS].includes(this.status)
    },
    bindEnabled() {
      return [AnswerStatus.OK, AnswerStatus.PASS].includes(this.status)
    },
    extraChanceToGetAward() {
      if (!this.$bus.currentBrowserInfo.isWeixin) return false
      if (!this.$bus.survey.otherSetting.extraChanceToGetAward) return false
      if (!this.$bus.params.accountUserId) return false
      if (!this.overData?.awardYuanAmount) return false
      return true
    },
    showAward() {
      return [AnswerStatus.OK, AnswerStatus.PASS,AnswerStatus.PASS].includes(this.status)
    },
    hasReward() {
      // return true
      return this.overData.hasReward
    },
    isOpenReward(){
      const data = this.$bus.currentAwardData || {}
      return hasValue(data.bindAward?.awardYuanAmount)
    },
    status() {
      // return 0
      return this.overData?.status
    },
    awardYuanAmount() {
      return this.overData.awardYuanAmount
    },
    showErrorMessage() {
      return this.status === AnswerStatus.QUALITY && this.auditDescription.length > 0
    },
    surveyId() {
      return this.$bus.survey.id
    },
    isIos() {
      let sUserAgent = navigator.userAgent.toLowerCase()
      return sUserAgent.match(/iphone os/i) == 'iphone os'
    },
    isIOSAPPHidden() {
      if (this.isIos) {
        // iphone
        if (this.isPlus) {
          // app
          return true // 隐藏
        } else {
          return false
        }
      }
      return false
    },
    ...busGetters([
      'closing',
      'overData',
      'award',
      'share',
      'enableNetManualAudit',
      'enableLuck',
      'showLuck',
      'enableMoreSurvey',
      'viewableAfterSubmit',
      'scoreEnd',
      'isAnswering',
      'auditDescription',
      'answerId',
      'answerTextTips',
      'showCopyright',
      'surveyPoint'
    ])
  },
  methods: {
    initHeight() {
      const innerHeight = this.$bus.innerHeight
      const offsetTop = this.$refs.container?.offsetTop || 0
      const minHeight = innerHeight - offsetTop - (this.$refs.footerContainer?.clientHeight || 0)
      this.$refs.container.style.minHeight = minHeight + 'px'
    },
    onCopyAnswerId() {
      copyText("#copyAnswerId",this.answerId).then(()=>{
        Notify({
          message: '复制成功',
          type: 'primary'
        })
      })
      // window.navigator.clipboard.writeText(this.answerId)

    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initHeight()
    })
    setTimeout(() => {
      uni.getEnv(res => {
        this.isPlus = !!res.plus
      })
    }, 1000)
    if (this.$bus.survey.otherSetting.enableAdsense) {
      initAnswerEndAdsense()
    }
  }
}
</script>
<style lang="scss">
$--end-bg-color: #f6f6f6;
.end {
  background-color: $--end-bg-color;

  &.bg-empty {
    background-color: transparent;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .operate-group {
    li {
      @apply text-small text-theme-black-650;
    }
  }

  .amount-of-money {
    font-size: 36px;
    color: #e34152;
  }
}
</style>
